import { useDecisionMakerProfilePageData } from '#src/app/pages/decisionMakerProfile/pageContext';

import type { ResponsivenessTags } from '../../utils/getScoreTag';
import { getScoreTag } from '../../utils/getScoreTag';

type Result = ModelHookResult<
	{
		responsivenessScore: number | null;
		scoreTag:
			| {
					label: string;
					labelColor: string;
					textColor: string;
			  }
			| undefined;
		totalRelevantPetitions: number | null;
		hasCountValues: boolean;
		respondedToPetitions: number | null;
		tags: ResponsivenessTags;
	},
	undefined
>;

export function useDmScoreData(): Result {
	const {
		data: {
			responsivenessData,
			featureConfigs: { dmProfileResponsivenessScoreConfig },
		},
	} = useDecisionMakerProfilePageData();

	const tagsList = dmProfileResponsivenessScoreConfig.tags || [];
	const tags = tagsList.map((tag) => ({
		...tag,
		rangeText: tag.min === 0 ? '0%' : `${tag.min}-${tag.max}%`,
	}));

	const score = responsivenessData.responsivenessScore;
	const dmScore = typeof score === 'number' ? Math.round(score) : null;

	const scoreTag = getScoreTag(tags, dmScore);
	const totalRelevantPetitions = responsivenessData.totalRelevantPetitions ?? null;
	const respondedToPetitions = responsivenessData.respondedToPetitions ?? null;

	return {
		data: {
			responsivenessScore: dmScore,
			totalRelevantPetitions,
			respondedToPetitions,
			hasCountValues: totalRelevantPetitions !== null && respondedToPetitions !== null,
			scoreTag,
			tags,
		},
	};
}
